export default "__VITE_ASSET__71xvwdNb__"